import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
function FormSection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      my: 1
    }
  }, children);
}
FormSection.propTypes = {
  children: PropTypes.any
};
export default FormSection;